import { Stack, Typography } from "@mui/material"
import React, { useMemo } from "react"
import StepPaymentItem from "./StepPaymentItem/StepPaymentItem"
import { UseFormWatch } from "react-hook-form"
import { TSale } from "../../../../../core/types/Sale"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { useCheckoutContext } from "../../../../../core/hooks/useCheckoutContext"

interface BoletoPaymentPrice8Props {
  visible: boolean
  index: number
  watch: UseFormWatch<TSale>
}

const BoletoPaymentPrice8 = ({
  visible,
  index,
  watch,
}: BoletoPaymentPrice8Props) => {
  const { displayCurrency } = useCheckoutContext()
  const values = useMemo(
    () => ({
      paymentPixValue: watch(`payment.payments.${index}.value`),
      paymentTotal: watch("payment.total"),
    }),
    [watch(`payment.payments.${index}.value`), watch("payment.total")]
  )

  return (
    <Stack spacing={1}>
      <Stack
        direction="column"
        spacing={1}
        sx={{ display: visible ? undefined : "none" }}
      >
        <Typography
          color="#464A5A"
          fontSize="16px"
          lineHeight="16px"
          fontWeight={500}
        >
          Clique em ”Finalizar Compra” para gerar o boleto. Informações sobre o
          pagamento via boleto:
        </Typography>

        <Typography
          color="#464A5A"
          fontSize="16px"
          lineHeight="16px"
          fontWeight={500}
        >
          <ul>
            <li>
              Valor a vista:{" "}
              <b style={{ fontSize: "20px" }}>
                {NumberFunctions.formatMoneyCurrency(values.paymentTotal, displayCurrency)}
              </b>
            </li>
            <li>
              Não pode ser parcelado! Use cartão de crédito para parcelar sua
              compra;
            </li>
            <li>
              Pagamentos com boleto levam até 3 dias úteis para serem
              compensados.
            </li>
          </ul>
        </Typography>
      </Stack>
    </Stack>
  )
}

export default BoletoPaymentPrice8
